import { BaseEntity } from './base-entity.model';

export enum CartStatus {
  WAITING_PLAN = "WAITING_PLAN",
  VERIFYING_DATA = "VERIFYING_DATA",
  WAITING_PAYMENT = "WAITING_PAYMENT",
  PAID = "PAID"
}


export class Cart extends BaseEntity {
  destination: string;
  locale: string;
  coupon: string;
  fullName: string;
  email: string;
  nDays: number;
  status: CartStatus;
  typeform1: any;
  typeform2: any;
  plan: string;
  total: number;
}
